import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";
import { useAiFeatureAccess } from "../../plan/aiFeatureGate/useAiFeatureAccess";
import { useAiSpendingWarning } from "../../aiAdministration/AiAdministration.hooks";
import { isAiSpendingExhausted } from "../../aiAdministration/AiAdministration.types";
import { getContractAiUpdateBlockedTranslationKey } from "./contractAiUpdateAccess";

/**
 * Whether to offer the AI-assisted update at all, and why it is disabled when it is.
 *
 * A missing add-on leaves the action visible so the customer can see what buying it would give them; a
 * missing edit permission hides it outright, since a permission is nothing we can sell them.
 */
export function useContractAiUpdateAffordance() {
    const { permissions } = useUserContext();
    const { showAffordance, planActivated: hasAiFeaturesAddOn } = useAiFeatureAccess();
    const { data: aiSpendingWarning } = useAiSpendingWarning();
    const spendingExhausted = isAiSpendingExhausted(aiSpendingWarning);

    return {
        showContractAiUpdate: showAffordance && permissions.contractManagementPermissions.permissions.edit,
        blockedTranslationKey: getContractAiUpdateBlockedTranslationKey({
            hasAiFeaturesAddOn,
            isAiSpendingExhausted: spendingExhausted,
        }),
        isAiSpendingExhausted: spendingExhausted,
    };
}
